import ayalon from '@app/assets/images/insurance-companies/ayalon.png';
import clal from '@app/assets/images/insurance-companies/clal.webp';
import fallback from '@app/assets/images/insurance-companies/fallback.png';
import hachshara from '@app/assets/images/insurance-companies/hachshara.svg';
import harel from '@app/assets/images/insurance-companies/harel.svg';
import menora from '@app/assets/images/insurance-companies/menora.png';
import migdal from '@app/assets/images/insurance-companies/migdal.png';
import phoenix from '@app/assets/images/insurance-companies/phoenix.svg';
import shlomo from '@app/assets/images/insurance-companies/shlomo.png';

/**
 * Insurance company logos, keyed by the filename stored on the company record.
 *
 * The API only carries the *name* of the image — the bytes ship with the client
 * bundle (assets/images/insurance-companies), so the deal room response stays
 * small and the browser serves the logo from its static asset cache. Drop a file
 * in that folder and register it below to introduce a new logo.
 */
export const insuranceCompanyImages: Record<string, string> = {
  'menora.png': menora,
  'phoenix.svg': phoenix,
  'clal.webp': clal,
  'hachshara.svg': hachshara,
  'ayalon.png': ayalon,
  'migdal.png': migdal,
  'harel.svg': harel,
  'shlomo.png': shlomo,
  'fallback.png': fallback,
};

/** Neutral shield shown for an insurer with no logo of its own. */
export const insuranceCompanyFallbackImage = fallback;

/**
 * Resolves a stored filename to a bundled asset, falling back to the neutral
 * shield. A company with no image at all resolves to undefined, so the caller
 * renders its name as text rather than a meaningless placeholder.
 */
export const getInsuranceCompanyImage = (image?: string | null): string | undefined => {
  if (!image) return undefined;
  return insuranceCompanyImages[image] ?? insuranceCompanyFallbackImage;
};
